import { z } from 'zod';

import { BaseWidgetSchema } from './BaseWidgetSchema';
import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { WidgetType } from '../../utils/widgetsUtils';
import { PageContentDisplayMode } from '../../utils/yjsUtils/types/PageContentDisplayMode';

export const SlideWidgetStaticSchema = BaseWidgetSchema(WidgetType.Slide).extend({
  title: z.string(),
  isHidden: z.boolean(),
  style: z.record(z.unknown()),
  stageStyle: z.record(z.unknown()),
  contentMinWidth: z.number().nullable().optional(),
  contentMaxWidth: z.number().nullable().optional(),
  displayMode: z.nativeEnum(PageContentDisplayMode),
  /**
   * ProseMirror JSON
   */
  speakerNotesFragment: ProseMirrorJSONSchema.optional(),
  hasCollaborativeWidget: z.boolean()
});

export type SlideWidgetStaticSchemaType = z.infer<typeof SlideWidgetStaticSchema>;
